import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Drag = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M7 16C7 15.4477 7.44772 15 8 15H32C32.5523 15 33 15.4477 33 16C33 16.5523 32.5523 17 32 17H8C7.44772 17 7 16.5523 7 16ZM7 24C7 23.4477 7.44772 23 8 23H32C32.5523 23 33 23.4477 33 24C33 24.5523 32.5523 25 32 25H8C7.44772 25 7 24.5523 7 24Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Drag;
